var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg-cloud-download",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico-cloud-download"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    style: {
      visibility: "hidden",
      opacity: 0,
      fill: "#FFFFFF"
    },
    width: 96,
    height: 96
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M92.059,38.019c0,12.368-10.062,22.43-22.43,22.43c-2.568,0-7.097,0.02-12.317,0.047l-0.042-8 c0.905-0.005,1.79-0.009,2.647-0.013c0.084,0,0.117-0.001,0.15-0.001c0.052,0,0.074,0,0.096,0c3.302-0.016,6.185-0.028,8.265-0.032 c0.039,0,0.074,0,0.109,0c0.021,0,0.042,0,0.062,0c0.026,0,0.052,0,0.077,0c0.082,0,0.123,0,0.165,0c0.15,0,0.17,0,0.19,0 c0.067,0,0.125,0,0.182,0c0.144,0,0.201,0,0.258,0c0.08,0,0.119,0,0.158,0c7.97,0,14.43-6.461,14.43-14.43 c0-7.97-6.461-14.431-14.43-14.431c-0.095,0-0.19,0.001-0.285,0.003c-3.067,0.06-5.89,1.088-8.202,2.775 c0.123-0.781,0.205-1.576,0.205-2.392c0-2.216-0.47-4.321-1.316-6.223c-2.386-5.367-7.765-9.109-14.017-9.109 c-6.296,0-11.703,3.795-14.063,9.222c-0.625,1.438-1.037,2.991-1.194,4.618c-1.23-0.318-2.512-0.505-3.841-0.505 c-0.346,0-0.688,0.011-1.028,0.034c-7.988,0.529-14.304,7.177-14.304,15.298c0,8.468,6.865,15.332,15.332,15.332 c0.034,0,0.068,0,0.102,0c0.149,0,0.203,0,0.257,0c0.08,0,0.101,0,0.123,0c0.058,0,0.081,0,0.105,0c0.323,0,0.348,0,0.372,0 c0.085,0,0.167,0,0.25,0c0.108,0,0.125,0,0.142,0c0.042,0,0.076,0,0.11,0c0.068,0,0.094,0,0.121,0c0.027,0,0.046,0,0.066,0 c2.341-0.005,5.33-0.018,8.704-0.035l0.04,8c-4.399,0.022-8.143,0.037-10.393,0.037c-12.866,0-23.332-10.467-23.332-23.332 c0-12.175,9.373-22.202,21.283-23.243c3.724-8.009,11.81-13.424,21.147-13.424c9.939,0,18.446,6.246,21.802,15.019 c0.6-0.048,1.205-0.072,1.812-0.072C81.996,15.589,92.059,25.651,92.059,38.019z M51.729,81.171V46.94 c0-2.372,1.931-4.302,4.303-4.302v-8c-6.783,0-12.302,5.519-12.302,12.302v34.29c-0.005,0.002-9.99-10.854-9.99-10.854 c-1.574,1.442-2.492,3.412-2.58,5.547c-0.091,2.138,0.659,4.181,2.105,5.753l11.308,12.229c1.7,1.839,4.607,1.839,6.307,0.001 l11.316-12.231c1.448-1.576,2.195-3.617,2.104-5.754c-0.089-2.135-1.008-4.104-2.583-5.546L51.729,81.171z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/cloud-download.bbb09c9a0dc6eeb941899cdf6d9f4315.svg";
export { ForwardRef as ReactComponent };